import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    '[Supabase] Faltan variables de entorno.\n' +
    'Asegurate de tener VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY en tu archivo .env.local'
  );
}

/**
 * Cliente Supabase — singleton.
 * Importar desde aquí en cualquier parte del proyecto:
 *   import { supabase } from '@/lib/supabase';
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Persiste la sesión en localStorage entre recargas
    persistSession: true,
    autoRefreshToken: true,
  },
});
